<template>    
    <div class="news-item--yotube news-item"  >
        <div class="news-item--yotube-inner" @click="getVideoSrc()" data-toggle="modal" :data-target="'#youtube-modal_' + id" :id="'youtube_item_' + id">
            <img v-if="src!='no-image'"  
                :srcset="srcset" 
                :alt="name" 
                :title="name" 
                class="img-fluid"                     
                :sizes="srcsizes" 
                :src="src_url + '/' + src" 
            />
            <img v-else 
                src='@/assets/images/noimage/video-no-image.svg' 
                :alt="name" 
                :title="name" 
                class="img-fluid"
                />
            <div class="name">{{  name }}</div>  
        </div>
        
        <!-- iframe - modal -->
        <div class="modal fade bd-example-modal-lg" tabindex="-1" role="dialog" :id="'youtube-modal_' + id">
            <div class="modal-dialog modal-lg modal-dialog-centered">
                <div class="modal-content">
                    <button  type="button" class="close" data-dismiss="modal" aria-label="Close"></button>
                    <div class="modal-body">
                        <iframe 
                            :id="id + '_youtube-player'"
                            frameborder="0" 
                            :height="youtubeHeight" 
                            :src="addYoutubeLink()" 
                            :width="youtubeWidth" 
                            allowfullscreen>
                        </iframe>
                    </div>
                </div>
            </div>
        </div>
        
    </div>    
</template>

<script>
import $ from "jquery"

export default {
    data(){
        return {
            categoryId: [],
            src_url: process.env.VUE_APP_BIFROST_API_URL_NO_PROJECTNAME,
            showVideo: false
        }
    },   
    props: ['name', 'date', 'id', 'news_slug', 'short_description', 'youtube_id', 'srcset', 'src', 'srcsizes'],
    computed:{                      
        categoryData(){             
            let categoryArray = this.$store.getters.getNewsCategory;                   
            return this.getCategoryData(this.id, categoryArray  )
        },       
        youtubeWidth(){
            
            if (window.matchMedia('(max-width: 840px)').matches){                
                return Math.floor(window.innerWidth)
            } else {
                return 800
            }
        },     
        youtubeHeight(){
            return this.youtubeWidth / (16/9)
        },
          
    },
    watch:{
        showVideo: function(){
            this.addYoutubeLink()
        }
    },
    methods:{
        addYoutubeLink(){                      
            let youtubelink = 'https://www.youtube.com/embed/' + this.youtube_id             
            return this.showVideo === true ? youtubelink : ''  
                                                     
        },
        getVideoSrc(){            
            this.GTMProdCatClick(this.name) 
            this.showVideo = true            
        },
        stopVideo(){            
            this.showVideo = false                                    
        },
        GTMProdCatClick(video){          
            this.setDataLayer('video_play', video, '')                  
        }
    },
    mounted(){
        let _this = this;
        
        $('#youtube-modal_' + _this.id).on('hidden.bs.modal', function () {                   
            _this.stopVideo()
        })
    }
}
</script>